import { render, staticRenderFns } from "./notificationDetails.vue?vue&type=template&id=f826128e"
import script from "./notificationDetails.vue?vue&type=script&lang=js"
export * from "./notificationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports